var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
var Category = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  transition: width 200ms ease-in-out;\n  width: ", "%;\n"], ["\n  background-color: ", ";\n  transition: width 200ms ease-in-out;\n  width: ", "%;\n"])), function (p) {
  return p.brand ? p.theme[p.brand] : 'transparent';
}, function (p) {
  return p.value;
});
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  display: flex;\n  height: 1rem;\n  overflow: hidden;\n"])), function (p) {
  return p.theme.colorLevel(p.theme.lowContrast, 0.5);
}, function (p) {
  return p.theme.borderRadius;
});

var ProgressBar = function ProgressBar(_a) {
  var categories = _a.categories,
      props = __rest(_a, ["categories"]);

  return React.createElement(Wrapper, Object.assign({
    className: "progress"
  }, props), categories.map(function (cat) {
    return React.createElement(Category, Object.assign({
      key: cat.name,
      className: "progress-bar",
      role: "progressbar",
      "aria-valuenow": cat.value,
      "aria-valuemin": 0,
      "aria-valuemax": 100
    }, cat));
  }));
};

export default ProgressBar;
var templateObject_1, templateObject_2;